import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';
import { Store } from 'game/store/gameStore';

let translationRecords = {} as { [key: string]: string };
let translationKeys = [] as string[];
const suppertedLanguages = [
    'bg',
    'cz',
    'de',
    'dk',
    'ee',
    'en',
    'es',
    'fi',
    'fr',
    'gr',
    'hr',
    'hu',
    'id',
    'it',
    'jp',
    'ko',
    'lt',
    'lv',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'se',
    'si',
    'sk',
    'sr',
    'tr',
    'zh',
];
export async function initLanguage() {
    try {
        const l = window.location.pathname.split('/')[1];
        if (suppertedLanguages.includes(l)) {
            await setLanguage(l);
        } else {
            await setLanguage('en');
        }
    } catch (e) {
        await setLanguage('en');
    }
}
export async function setLanguage(lang: string) {
    const fetchLang = () => import(`./translations/${lang}.js`);
    const response = await fetchLang();
    const dictionary = response.default;
    Store.language = lang;
    translationRecords = dictionary;
    translationKeys = Object.keys(translationRecords);
    GameEvent.emit(EventName.CHANGE_LANGUAGE);
}
export function translate(key: string) {
    if (!translationKeys.includes(key)) {
        console.error('no translation for ' + key + ' in language ' + Store.language);
        return key;
    }
    return translationRecords[key];
}
